import { render } from "./alarm_setting.vue?vue&type=template&id=a4438ff0"
import script from "./alarm_setting.vue?vue&type=script&lang=js"
export * from "./alarm_setting.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__